export default {
  ui: {
    alert: null,
    notification: null,
    isSystemInitialised: false,
  },
};
